import Vue from 'vue';
import Vuex from 'vuex'
import App from './App.vue';
import i18n from '@/plugins/i18n';
import FlagIcon from 'vue-flag-icon';
import router from './router'
import store from '@/plugins/store'
import RadialProgressBar from 'vue-radial-progress'
/*import VueProgress from 'vue-progress'
import VueCircle from 'vue2-circle-progress'
Vue.use(VueCircle)
Vue.use(VueProgress)*/
Vue.use(RadialProgressBar);
Vue.use(FlagIcon);
Vue.use(Vuex);
Vue.config.productionTip = false;
//i18n.init({ detectLngQS: 'lang' });

new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app');